module.exports = __webpack_public_path__ + "static/media/Celularplantita1.2d40cb35.png";